import { render, staticRenderFns } from "./MainLinks.vue?vue&type=template&id=f2ddf9da&scoped=true&"
import script from "./MainLinks.vue?vue&type=script&lang=js&"
export * from "./MainLinks.vue?vue&type=script&lang=js&"
import style0 from "./MainLinks.vue?vue&type=style&index=0&id=f2ddf9da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ddf9da",
  null
  
)

export default component.exports